module.exports = __webpack_public_path__ + "static/media/brandlogo.ff56935c.png";